<template>
  <PageLoader :loading="loading">
    <ThankYouPage />
  </PageLoader>
</template>

<script lang="ts">
import PageLoader from "@/components/pages/PageLoader";
import ThankYouPage from "@/components/pages/thank-you";
import {
  handleStringReturnRedirect,
  trackConversionEventOnce,
} from "~/components/pages/thank-you/lib";

export default defineComponent({
  components: { PageLoader, ThankYouPage },
  setup() {
    definePageMeta({
      layout: "blank",
      seo: {
        title: "Thank you!",
      },
    });

    const checkout = useCheckout();
    const token = getQueryParam("token");

    const error = (message?: string): never => {
      throw createError({ statusCode: 404, statusMessage: message });
    };

    if (!token) {
      error();
    }

    checkout.load(token!).then((data) => {
      if (!data) {
        error();
      }

      if (!data!.completed) {
        const clientSecret = getQueryParam("payment_intent_client_secret");
        if (clientSecret) {
          const config = useRuntimeConfig();
          handleStringReturnRedirect(
            config.public.stripe.key,
            clientSecret
          ).then((status) => {
            if (!status.ok) {
              error(status.message);
            }
          });
        } else {
          // nav back to checkout
          const webUrl = checkout.getWebUrl();
          if (webUrl) {
            window.location.href = webUrl;
          }
        }
      } else {
        trackConversionEventOnce(data!);
      }
    });

    return {
      loading: checkout.loading,
    };
  },
});
</script>
